// extracted by mini-css-extract-plugin
export default {"search":"custom-search_search__W4-o5","searchIcon":"custom-search_searchIcon__3lUQA"};